/**
 * Libs
 */
import React from 'react';

/**
 * Styles
 */

import { PageLayout } from 'src/ui/common/layouts/page-layout';
import { StyledTechPageContent } from '../../styles';

export const TechPageContent: React.FC = ({ children }) => (
    <StyledTechPageContent>
        <PageLayout fullWidth={false}>{children}</PageLayout>
    </StyledTechPageContent>
);
